import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { SeFeCardModule } from 'se-fe-card'
import { SeFeDocsExampleModule } from 'se-fe-docs-example'
import { SeFeHeaderModule } from 'se-fe-header'
import { SeFePageModule } from 'se-fe-page'
import { SharedUiEthnicitySelectModule } from '../lib/shared-ui-ethnicity-select.module'
import { EthnicitySelectDocsComponent } from './ethnicity-select-docs/ethnicity-select-docs.component'
import { EthnicitySelectExampleComponent } from './ethnicity-select-docs/ethnicity-select-example.component'

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SeFeCardModule,
    SeFeDocsExampleModule,
    SeFeHeaderModule,
    SeFePageModule,
    SharedUiEthnicitySelectModule
  ],
  declarations: [
    EthnicitySelectDocsComponent,
    EthnicitySelectExampleComponent
  ],
  exports: [
    EthnicitySelectDocsComponent
  ]
})
export class SharedUiEthnicitySelectDocsModule {}
